/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { PriceSettingsDto } from './PriceSettingsDto';
import {
    PriceSettingsDtoFromJSON,
    PriceSettingsDtoFromJSONTyped,
    PriceSettingsDtoToJSON,
    PriceSettingsDtoToJSONTyped,
} from './PriceSettingsDto';

/**
 * 
 * @export
 * @interface GetPriceSettingsResponse
 */
export interface GetPriceSettingsResponse {
    /**
     * 
     * @type {Array<PriceSettingsDto>}
     * @memberof GetPriceSettingsResponse
     */
    priceSettings: Array<PriceSettingsDto> | null;
}

/**
 * Check if a given object implements the GetPriceSettingsResponse interface.
 */
export function instanceOfGetPriceSettingsResponse(value: object): value is GetPriceSettingsResponse {
    if (!('priceSettings' in value) || value['priceSettings'] === undefined) return false;
    return true;
}

export function GetPriceSettingsResponseFromJSON(json: any): GetPriceSettingsResponse {
    return GetPriceSettingsResponseFromJSONTyped(json, false);
}

export function GetPriceSettingsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPriceSettingsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'priceSettings': (json['priceSettings'] == null ? null : (json['priceSettings'] as Array<any>).map(PriceSettingsDtoFromJSON)),
    };
}

export function GetPriceSettingsResponseToJSON(json: any): GetPriceSettingsResponse {
    return GetPriceSettingsResponseToJSONTyped(json, false);
}

export function GetPriceSettingsResponseToJSONTyped(value?: GetPriceSettingsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'priceSettings': (value['priceSettings'] == null ? null : (value['priceSettings'] as Array<any>).map(PriceSettingsDtoToJSON)),
    };
}

